<template>
  <div class="tours">
    <div class="top">
      <div class="title">成功案例</div>
    </div>
    <div class="nav">
      <div class="nav-con">
        {{ name }}
      </div>
    </div>
    <el-image class="big-img" :src="imgUrl" :preview-src-list="imgUrlList">
    </el-image>
  </div>
</template>

<script>

export default {
  data() {
    return {
      name: "",
      imgUrl: "",
      imgUrlList: []
    }
  },
  mounted() {
    console.log(this.$route.query);
    this.name = this.$route.query.name;
    this.imgUrl = this.$route.query.img;
    this.imgUrlList = [this.$route.query.img]
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
.tours {
  padding-bottom: 180px;
  background-color: #f1f1f1;

  .big-img {
    width: 80%;
    max-width: 1000px;
    margin: 40px auto;
    display: block;
  }

  .lists {
    display: flex;
    max-width: 1200px;
    margin: 0 auto;
    flex-wrap: wrap;

    .list {
      width: calc(25% - 30px);
      margin: 40px 10px 0;
      background-color: #fff;
      border-radius: 6px;
      overflow: hidden;
      transition: .3s all;
      padding: 10px;
      box-sizing: border-box;
      box-shadow: 0 0 10px #ccc;
      cursor: pointer;

      .img {
        width: 100%;
        height: 360px;
        overflow: hidden;

        img {
          width: 100%;
          height: auto;
          transition: .3s all;
        }
      }

      &:hover {
        .name {
          color: #ae0000;
        }
      }

      .name {
        transition: .3s all;
        font-size: 17px;
        color: #333;
      }
    }
  }

  .nav {
    width: 100%;
    padding: 30px 0;
    background-color: #ae0000;
    border: 20px solid #fff;
    border-left: none;
    border-right: none;

    .nav-con {
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 6px;
      color: #fff;
      font-size: 20px;
    }
  }

  .top {
    width: 100vw;
    height: 340px;
    position: relative;
    overflow: hidden;
    background-image: url('../../assets/imgs/study_in_australia.jpg');
    background-size: auto 100%;
    transition: .3s all;
    background-position: center;

    .title {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 60px;
      font-weight: 600;
      letter-spacing: 2px;
      color: #ae0000;
      text-shadow: 3px 3px 5px #fff;
    }



    img {
      width: 100%;
      object-fit: cover;
      height: 100%;
      transition: .3s all;
    }

    &:hover {
      background-size: auto 110%;

      img {
        transform: scale(1.1);
      }
    }
  }


}


@media (max-width: 600px) {
  .tours {
    padding-bottom: 30px;

    .top {
      height: 200px;

      .title {
        font-size: 30px;
      }
    }

    .nav {
      padding: 10px 0;
      border-width: 10px;

      .nav-con {
        font-size: 16px;
      }
    }

    .lists {
      .list {
        width: calc(50% - 20px);
        margin: 20px 10px 0;

        .img {
          height: 200px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/zh/goodNewsDetail.vue